import { EditorTheme } from '@loyalty/shared-common/template-api-client';

export const defaultEditorTheme: EditorTheme = {
  global: {
    backgroundColor: '#F4F4F4',
    primaryColor: '#C9AD67',
    secondaryColor: '#1A2434',
    blocksColor: '#FFFFFF',
    globalRadius: 5,
    imageRadius: 100,
  },
  text: {
    paragraph: {
      fontFamily: 'Open Sans',
      fontWeight: '400',
      color: '#4F4F4F',
      fontSize: 14,
      linkColor: '#C9AD67',
    },
    title: {
      fontFamily: 'Raleway',
      fontWeight: '800',
      color: '#1A2434',
      fontSize: 25,
    },
    subtitle: {
      fontFamily: 'Raleway',
      fontWeight: '800',
      color: '#1A2434',
      fontSize: 19,
    },
  },
  button: {
    fontFamily: 'Raleway',
    fontSize: 16,
    fontWeight: '800',
    color: '#FFFFFF',
    backgroundColor: '#C9AD67',
    borderRadius: 100,
  },
  progressBar: {
    backgroundColor: '#EAEAEA',
    progressColor: '#12384A',
  },
};

export function getThemeColors(theme: EditorTheme): string[] {
  const colors = [
    theme.global.backgroundColor,
    theme.global.primaryColor,
    theme.global.secondaryColor,
    theme.global.blocksColor,
    theme.text.paragraph.color,
    theme.text.paragraph.linkColor,
    theme.text.title.color,
    theme.text.subtitle.color,
    theme.button.color,
    theme.progressBar.backgroundColor,
    theme.progressBar.progressColor,
  ];
  return Array.from(new Set(colors));
}
